import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry, timer } from 'rxjs';

const MAX_ATTEMPTS = 3;

@Injectable()
export class IconsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('assets/icons/')) return next.handle(req);
    return next.handle(req).pipe(
      retry({
        count: MAX_ATTEMPTS,
        delay: (_, count) => timer(count * 1000),
      })
    );
  }
}
